import { useMemo } from 'react';
import { registerMutation, useMutation } from 'data-fetching-client';
import { GET_ASSOCIATED_CAMPAIGN_FIELD_NAME } from 'asset-actions-lib-forms/selectCampaign/hooks/useFetchAssociatedCampaign';
import http from 'hub-http/clients/apiClient';
export const ASSOCIATE_CAMPAIGN_FIELD_NAME = 'associateCampaign';
export const ASSOCIATE_CAMPAIGN = registerMutation({
  fieldName: ASSOCIATE_CAMPAIGN_FIELD_NAME,
  args: ['formCrmObjectId', 'campaignGuid', 'deleteAssociation'],
  fetcher({
    formCrmObjectId,
    campaignGuid,
    deleteAssociation = false
  }) {
    if (deleteAssociation) {
      return http.delete('campaigns/associations/assets/delete', {
        data: {
          campaignGuids: [campaignGuid],
          assetObjectType: 'FORM',
          crmAssetIds: [formCrmObjectId]
        }
      });
    }
    return http.put('campaigns/associations/assets/create', {
      data: {
        campaignGuids: [campaignGuid],
        assetObjectType: 'FORM',
        crmAssetIds: [formCrmObjectId]
      }
    });
  }
});
export function useAssociateCampaign({
  formCrmObjectId,
  campaignGuid
}) {
  const [associateCampaign, {
    error,
    loading
  }] = useMutation(ASSOCIATE_CAMPAIGN, {
    update: (cache, _data, {
      variables
    }) => {
      const newlyAssociatedCampaign = variables === null || variables === void 0 ? void 0 : variables.campaignGuid;
      const associationDeleted = variables === null || variables === void 0 ? void 0 : variables.deleteAssociation;
      if (newlyAssociatedCampaign) {
        cache.modify({
          id: 'ROOT_QUERY',
          fields: {
            [GET_ASSOCIATED_CAMPAIGN_FIELD_NAME]: () => {
              return associationDeleted ? null : newlyAssociatedCampaign;
            }
          },
          optimistic: true
        });
      }
    },
    variables: {
      formCrmObjectId,
      campaignGuid
    }
  });
  return useMemo(() => ({
    associateCampaign,
    error,
    loading
  }), [associateCampaign, error, loading]);
}